
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyBarrelDanger as ObiBuoyBarrelDangerElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-barrel-danger.js';
 
 
 

 
 export const ObiBuoyBarrelDanger = createComponent({
   react: React,
   tagName: 'obi-buoy-barrel-danger',
   elementClass: ObiBuoyBarrelDangerElement,
   events: {
     
   }
  });
 
 